import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import CartPage from "../components/common/headers/common/cart-header";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getColorCodeBasedOnKey,
  getOpenStoreIdApp,
} from "../store";
import { getCall } from "../api/post";
import { isInquiryOrCart, getCommonCounter } from "../actions";
import {
  getSettingUrl,
  getShippingOptionsUrl,
  getMerchantInformationUrl,
  getPincodeDeliveryUrl,
  getMasterDetailsIdUrl,
} from "../services";
import ErrorMessageAnimationModal from "../animation/ErrorMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../utils/utils";
import { checkAuthAndRedirect, getCurrentPath } from "../utils/cartRedirect";

class CartContainer extends Component {
  constructor() {
    super();
    this.state = {
      cartList: [],
      isMerchantGSTEnable: false,
      merchantInfo: {},
      shippingCharges: [],
      currentCatelogueType: {},
      isPincodeDeliveryEnable: false,
      showErrorMessageModal: false,
      errorMessage: "",
      masterDetailsObj: {},
      showCartDetailsDiv: false,
      orderDetails: [],
    };
  }

  componentDidMount() {
    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.props.isInquiryOrCart(masterDetailsObj);
      this.props.counter();
      this.initCartList();
      this.initMerchantInfo();
      this.initCatelogueSettings();
      this.initShippingCharges();
      this.initPincodeDelivery();
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initCartList = async () => {
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;
    const cartListUrl = `orders?filter[where][userId]=${userId}&filter[where][inshoppingcart]=1&filter[order]=created`;

    const cartList = await getCall(cartListUrl, []);
    if (cartList.error) {
      clearLocalStorageReload({ response: cartList });
      this.loadErrorMessageAnimation(cartList.error.message);
      if (cartList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, "/login");
        return;
      }
    } else {
      this.setState({ cartList });
      if (cartList && Array.isArray(cartList) && cartList.length > 0 && cartList[0] && cartList[0].orderdetail) {
        this.setState({ orderDetails: cartList[0].orderdetail });
      } else {
        this.setState({ orderDetails: [] });
      }
    }
    // Call counter API after cart list is updated
    if (this.props.fetchHeaderCounters) {
      this.props.fetchHeaderCounters();
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({ isMerchantGSTEnable: false, merchantInfo: {} });
    } else {
      this.setState({
        merchantInfo,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      if (settingInfo && Array.isArray(settingInfo)) {
        settingInfo.forEach((setting) => {
          if (
            setting &&
            (setting.registerallow === "Catalogue_FMCG" ||
              setting.registerallow === "Catalogue_Jewellary" ||
              setting.registerallow === "Catalogue_Electronics" ||
              setting.registerallow === "Catalogue_FABRIC") &&
            setting.status === 1
          ) {
            settings = setting;
          }
        });
      }
      this.setState({ currentCatelogueType: settings });
    }
  };

  initShippingCharges = async () => {
    const { masterDetailsObj } = this.state;
    const shippingChargesUrl = getShippingOptionsUrl(masterDetailsObj);
    const shippingCharges = await getCall(shippingChargesUrl, []);
    if (shippingCharges.error) {
      clearLocalStorageReload({ response: shippingCharges });
    }
    this.setState({ shippingCharges: shippingCharges });
  };

  getTotalofCart(cartList) {
    let total = 0;
    if (cartList && Array.isArray(cartList) && cartList.length > 0 && cartList[0] && cartList[0].orderdetail && Array.isArray(cartList[0].orderdetail)) {
      for (let i = 0; i < cartList[0].orderdetail.length; i++) {
        const orderDetail = cartList[0].orderdetail[i];
        if (orderDetail && orderDetail.amount && orderDetail.quantity) {
          total = total + (orderDetail.amount * orderDetail.quantity);
        }
      }
    }
    return total;
  }

  getShippingPriceFromCart() {
    const { cartList } = this.state;
    let total = 0;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        if (cartList[i] && cartList[i].shippingprice) {
          total = cartList[i].shippingprice;
        }
      }
    }
    return total;
  }

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.CGST) / 100;
  };
  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.SGST) / 100;
  };

  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.IGST) / 100;
  };

  getShippingCharges = (total) => {
    const { shippingCharges, isPincodeDeliveryEnable } = this.state;
    var charge = 0;

    if (isPincodeDeliveryEnable) {
      return this.getShippingPriceFromCart();
    }

    if (shippingCharges && Array.isArray(shippingCharges) && shippingCharges.length > 0) {
      for (let index = 0; index < shippingCharges.length; index++) {
        const shippingCharge = shippingCharges[index];
        if (
          shippingCharge &&
          shippingCharge.id === 3 &&
          shippingCharge.status === 1 &&
          shippingCharge.options &&
          Array.isArray(shippingCharge.options)
        ) {
          for (
            let jindex = 0;
            jindex < shippingCharge.options.length;
            jindex++
          ) {
            const option = shippingCharge.options[jindex];
            if (option) {
              if (
                !option.maxCondition &&
                option.minValue <= total &&
                option.maxValue >= total
              ) {
                charge = option.charges;
                break;
              }
              if (
                option.maxCondition &&
                option.minValue <= total
              ) {
                charge = option.charges;
                break;
              }
            }
          }
        }
      }
    }

    return charge;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharge) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (merchantInfo.enablegst === 0) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }
    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }
    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + shippingCharge;
    } else {
      grandTotal = total + igst + shippingCharge;
    }
    return grandTotal;
  };

  deleteProductFromCart = async (item) => {
    // ...your delete logic...
    await this.initCartList();
    if (this.props.fetchHeaderCounters) {
      this.props.fetchHeaderCounters();
    }
  };

  UNSAFE_componentWillUpdate = (prevProps, nextState) => {
    // console.log("nextState");
    // console.log(nextState);
    // console.log("prevProps");
    // console.log(prevProps);
    if (
      this.props.cartCounter !== prevProps.cartCounter ||
      this.props.updateQuantity !== prevProps.updateQuantity
    ) {
      this.initCartList();
    }
  };

  initPincodeDelivery = async () => {
    const { masterDetailsObj } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const pincodeDelivery = await getCall(
      getPincodeDeliveryUrl(masterDetailsObj),
      []
    );
    if (pincodeDelivery.error) {
      clearLocalStorageReload({ response: pincodeDelivery });
      this.loadErrorMessageAnimation(pincodeDelivery.error.message);
    } else {
      if (pincodeDelivery.length > 0) {
        const status = pincodeDelivery[0].status;
        this.setState({ isPincodeDeliveryEnable: status === 1 ? true : false });
      }
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  handleCartClick = (e) => {
    // Check authentication first
    const currentPath = getCurrentPath(this.props);
    if (!checkAuthAndRedirect(this.props, currentPath)) {
      e.preventDefault(); // Prevent the default link navigation
      return; // User was redirected to login
    }
    // If authenticated, let the link work normally
  };

  render() {
    const { symbol, cartCounter, isInquiry } = this.props;
    const {
      cartList,
      isMerchantGSTEnable,
      currentCatelogueType,
      showErrorMessageModal,
      errorMessage,
    } = this.state;
    return (
      <>
        <div className={` ${!isInquiry ? "" : "hide-settings-cart"}`}>
          <div className="cart-qty-cls">{cartCounter}</div>
          <Link to={`/cart`} onClick={this.handleCartClick}>
            {/* <img
              src={`${process.env.PUBLIC_URL}/assets/images/icon/shopping-cart.png`}
              alt=""
              className="img-fluid"
              // onClick={() => {
              //   this.setState({ showCartDetailsDiv: true });
              // }}
            /> */}
            {/* <i className="fa fa-shopping-cart ml-1" title="Cart" /> */}
            <svg width="24" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M34.8129 21.1877C35.5536 21.5343 36.2942 21.8809 37.0573 22.238C38.7417 23.0272 40.4227 23.8236 42.101 24.6257C45.3903 26.185 48.6976 27.7016 52.0082 29.215C54.4853 30.3506 56.9616 31.4878 59.4379 32.6252C60.6101 33.163 61.7822 33.7007 62.9899 34.2548C78.3984 41.3993 91.4277 48.0135 99.0004 64.0002C103.403 76.1804 106.194 88.7884 109.043 101.399C109.525 103.51 110.008 105.62 110.491 107.731C111.524 112.251 112.553 116.772 113.579 121.293C115.206 128.461 116.843 135.626 118.481 142.791C123.542 164.942 128.575 187.1 133.584 209.263C135.096 215.95 136.608 222.637 138.124 229.324C138.271 229.973 138.418 230.623 138.57 231.293C139.306 234.538 140.042 237.784 140.778 241.03C142.503 248.64 144.22 256.252 145.93 263.865C146.996 268.601 148.069 273.336 149.144 278.07C149.642 280.272 150.137 282.474 150.629 284.678C151.301 287.686 151.984 290.692 152.67 293.697C152.863 294.574 153.056 295.451 153.255 296.355C154.6 302.179 155.809 306.539 161 310C163.087 310.299 163.087 310.299 165.416 310.252C166.325 310.257 167.233 310.262 168.169 310.268C169.169 310.263 170.168 310.259 171.198 310.254C172.789 310.259 172.789 310.259 174.413 310.264C177.985 310.272 181.557 310.265 185.129 310.259C187.683 310.262 190.237 310.265 192.79 310.27C199.018 310.278 205.246 310.277 211.474 310.271C216.535 310.266 221.596 310.266 226.658 310.268C227.377 310.268 228.097 310.268 228.839 310.269C230.301 310.269 231.763 310.27 233.225 310.271C246.944 310.276 260.664 310.27 274.383 310.259C286.157 310.25 297.93 310.252 309.704 310.261C323.371 310.272 337.037 310.276 350.703 310.27C352.161 310.269 353.618 310.268 355.076 310.268C355.793 310.268 356.51 310.267 357.249 310.267C362.303 310.265 367.358 310.268 372.413 310.273C379.217 310.279 386.021 310.275 392.825 310.263C395.326 310.26 397.827 310.261 400.327 310.266C403.734 310.271 407.141 310.264 410.549 310.254C412.041 310.261 412.041 310.261 413.564 310.268C420.087 310.378 420.087 310.378 426 308C427.161 305.782 427.161 305.782 427.642 303.094C427.872 302.102 428.102 301.11 428.339 300.088C428.667 298.559 428.667 298.559 429 297C429.448 295.148 429.898 293.296 430.35 291.445C430.814 289.463 431.277 287.48 431.737 285.497C431.993 284.403 432.248 283.308 432.512 282.18C433.354 278.575 434.193 274.969 435.032 271.363C435.629 268.804 436.226 266.244 436.823 263.684C438.079 258.302 439.332 252.92 440.585 247.538C441.846 242.12 443.109 236.703 444.372 231.287C444.526 230.629 444.679 229.972 444.837 229.294C444.99 228.638 445.144 227.982 445.301 227.306C448.342 214.272 451.375 201.237 454.399 188.199C456.106 180.844 457.82 173.491 459.543 166.14C460.591 161.657 461.634 157.173 462.675 152.688C463.157 150.616 463.642 148.544 464.13 146.474C464.795 143.648 465.451 140.821 466.104 137.993C466.298 137.177 466.493 136.362 466.693 135.521C467.962 129.966 469.145 124.576 466.75 119.188C464.858 116.822 463.78 116.103 461 115C458.518 114.702 458.518 114.702 455.799 114.747C454.74 114.741 453.682 114.736 452.591 114.73C450.848 114.736 450.848 114.736 449.07 114.742C447.835 114.738 446.6 114.735 445.327 114.731C441.897 114.722 438.467 114.723 435.037 114.727C431.338 114.73 427.639 114.721 423.94 114.713C417.529 114.701 411.119 114.696 404.708 114.695C395.43 114.694 386.152 114.679 376.874 114.66C361.81 114.629 346.746 114.605 331.683 114.587C330.33 114.585 330.33 114.585 328.95 114.584C318.892 114.572 308.834 114.562 298.776 114.553C295.131 114.55 291.485 114.547 287.84 114.544C286.491 114.543 286.491 114.543 285.114 114.542C270.112 114.528 255.11 114.504 240.107 114.47C230.854 114.45 221.601 114.44 212.348 114.442C206.006 114.443 199.663 114.434 193.321 114.415C189.662 114.405 186.004 114.4 182.345 114.408C178.376 114.417 174.407 114.402 170.439 114.385C169.286 114.392 168.133 114.398 166.945 114.404C159.764 114.349 153.498 113.913 147.758 109.133C143.011 103.296 140.466 99.0768 140.696 91.4025C141.359 86.1727 143.107 81.8176 146.942 78.1369C151.658 74.4976 155.168 72.8775 161.19 72.866C162.272 72.8615 163.353 72.857 164.467 72.8525C165.659 72.8526 166.852 72.8528 168.08 72.853C169.344 72.8493 170.607 72.8457 171.909 72.8419C175.423 72.8318 178.937 72.8281 182.451 72.8255C186.238 72.8216 190.026 72.812 193.814 72.8033C202.966 72.7835 212.119 72.7734 221.272 72.7645C225.584 72.7602 229.896 72.7548 234.207 72.7496C248.545 72.7325 262.883 72.718 277.221 72.7108C280.943 72.7089 284.665 72.707 288.386 72.705C289.311 72.7045 290.236 72.7041 291.189 72.7036C306.16 72.6953 321.131 72.6699 336.101 72.6374C351.478 72.6043 366.854 72.5864 382.23 72.5832C390.861 72.581 399.491 72.5723 408.122 72.5467C415.475 72.5249 422.829 72.517 430.182 72.5267C433.931 72.5312 437.679 72.5294 441.427 72.5099C445.502 72.4889 449.576 72.4993 453.651 72.5124C455.406 72.496 455.406 72.496 457.197 72.4792C472.369 72.5968 484.818 77.9236 495.813 88.3127C506.457 99.5835 510.89 112.873 510.483 128.299C509.748 140.175 506.342 151.848 503.555 163.382C502.609 167.317 501.685 171.256 500.759 175.196C499.545 180.359 498.327 185.521 497.1 190.681C493.842 204.384 490.651 218.101 487.483 231.825C485.86 238.858 484.232 245.89 482.605 252.923C481.266 258.712 479.928 264.502 478.591 270.293C477.321 275.797 476.044 281.299 474.763 286.8C474.29 288.836 473.819 290.873 473.35 292.909C468.621 313.445 464.255 332.088 445.875 344.688C431.37 353.227 417.236 352.574 400.854 352.518C398.203 352.523 395.552 352.53 392.902 352.539C386.473 352.557 380.045 352.553 373.617 352.541C368.389 352.532 363.16 352.531 357.932 352.535C356.812 352.536 356.812 352.536 355.669 352.537C354.152 352.539 352.635 352.54 351.118 352.541C336.921 352.553 322.724 352.54 308.527 352.518C296.368 352.5 284.209 352.503 272.051 352.522C257.901 352.543 243.752 352.551 229.603 352.539C228.092 352.538 226.58 352.537 225.069 352.535C224.326 352.535 223.582 352.534 222.816 352.534C217.599 352.53 212.383 352.536 207.166 352.545C200.8 352.557 194.435 352.553 188.07 352.532C184.828 352.522 181.586 352.52 178.344 352.531C158.136 352.594 142.998 351.112 127.313 337.063C114.705 323.235 111.845 304.768 107.948 287.109C107.073 283.171 106.175 279.238 105.279 275.305C103.698 268.353 102.131 261.397 100.572 254.44C97.8268 242.196 95.034 229.963 92.2387 217.731C91.2428 213.37 90.2472 209.01 89.2516 204.65C89.004 203.565 88.7563 202.48 88.5012 201.363C85.7863 189.471 83.0792 177.578 80.3754 165.684C80.1408 164.652 79.9062 163.62 79.6644 162.556C76.8386 150.124 74.0261 137.689 71.2339 125.25C70.1806 120.562 69.1226 115.874 68.0652 111.187C67.2764 107.678 66.4961 104.167 65.7162 100.656C65.2541 98.6056 64.7916 96.5548 64.3285 94.5041C64.0349 93.1618 64.0349 93.1618 63.7353 91.7924C62.2115 83.8725 62.2115 83.8725 57.3487 77.8435C55.2102 76.6793 53.0438 75.6721 50.8168 74.6877C50.0061 74.3109 49.1953 73.9341 48.36 73.5458C45.7688 72.346 43.1666 71.1726 40.5629 70.0002C38.8466 69.2129 37.1311 68.4239 35.4164 67.633C32.9126 66.4791 30.4085 65.326 27.9019 64.178C6.49886 54.3718 6.49886 54.3718 2.90667 46.6486C0.903406 40.7942 1.05149 34.2771 3.62542 28.6252C6.3866 23.8806 9.80602 21.0242 14.8129 18.6877C22.2589 17.0817 28.0347 17.8589 34.8129 21.1877Z" fill="black" />
              <path d="M233.601 401.008C244.622 410.564 252.103 421.198 254 436C255.017 451.058 251.734 464.655 241.75 476.187C231.761 486.669 220.74 493.207 205.992 494.203C190.408 494.437 177.662 490.184 166.32 479.375C155.64 468.444 150.727 456.152 150.753 440.868C150.971 428.504 155.85 415.603 164.39 406.512C183.354 388.699 212.273 384.548 233.601 401.008ZM186.418 433.062C183.541 436.993 183.405 441.306 184 446C186.203 452.848 190.134 456.919 196.437 460.312C202.387 461.909 206.844 461.174 212.14 458.269C216.524 455.276 219.616 451.157 221 446C221.674 440.046 220.368 435.837 217 431C213.473 427.297 210.224 424.319 204.949 423.797C196.211 423.616 192.014 426.54 186.418 433.062Z" fill="black" />
              <path d="M410 400C420.498 407.659 427.387 418.722 430.582 431.289C433.148 447.928 429.383 462.006 419.786 475.738C412.603 485.098 400.182 491.959 388.621 493.754C373.125 495.209 359.795 492.527 347.301 482.926C335.728 473.013 329.069 460.578 327.778 445.379C327.319 431.632 331.569 418.812 340.328 408.172C358.946 388.617 387.318 384.992 410 400ZM365.125 430.875C361.446 436.286 360.537 440.428 361.461 446.824C362.829 452.342 366.434 455.882 371 459C375.073 461.143 378.429 461.394 383 461C389.421 458.897 393.118 455.856 396.813 450.25C398.902 444.531 398.895 439.364 396.438 433.75C393.618 428.705 389.412 425.804 384 424C376.35 423.351 370.381 425.018 365.125 430.875Z" fill="black" />
            </svg>

          </Link>

          {this.state.showCartDetailsDiv && (
            <ul className="show-div shopping-cart d-none">
              {cartList.length > 0 &&
                cartList[0].orderdetail.map((item, index) => (
                  <CartPage
                    key={index}
                    item={item}
                    symbol={symbol}
                    removeFromCart={() => this.deleteProductFromCart(item)}
                  />
                ))}

              {cartList.length > 0 ? (
                <>
                  <li>
                    {!isInquiry && (
                      <div className="total">
                        <h5>
                          {getValueFromLanguageObject(
                            "str_sub_total_with_colon"
                          )
                            ? getValueFromLanguageObject(
                              "str_sub_total_with_colon"
                            )
                            : "Sub Total : "}
                          <span>
                            {`${symbol}${parseFloat(
                              this.getTotalofCart(cartList)
                            ).toFixed(2)}`}
                          </span>
                        </h5>

                        <h5>
                          {`+ ${getValueFromLanguageObject(
                            "shipping_charges_with_colun"
                          )
                              ? getValueFromLanguageObject(
                                "shipping_charges_with_colun"
                              )
                              : "Shipping Charges : "
                            }`}

                          <span>
                            {`${symbol}${parseFloat(
                              this.getShippingCharges(
                                this.getTotalofCart(cartList)
                              )
                            ).toFixed(2)}`}
                          </span>
                        </h5>
                        {isMerchantGSTEnable &&
                          currentCatelogueType &&
                          currentCatelogueType.registerallow !==
                          "Catalogue_Jewellary" &&
                          this.state.merchantInfo.countryname === "India" && (
                            <h5>
                              {`+ ${getValueFromLanguageObject("str_cgst")
                                  ? getValueFromLanguageObject("str_cgst")
                                  : "CGST"
                                } (${this.state.merchantInfo.CGST}%) :`}
                              <span>
                                {`${symbol}${parseFloat(
                                  this.getCGSTFromTotal(
                                    this.getTotalofCart(cartList)
                                  )
                                ).toFixed(2)}`}
                              </span>
                            </h5>
                          )}

                        {isMerchantGSTEnable &&
                          currentCatelogueType &&
                          currentCatelogueType.registerallow !==
                          "Catalogue_Jewellary" &&
                          this.state.merchantInfo.countryname === "India" && (
                            <h5>
                              {`+ ${getValueFromLanguageObject("str_sgst")
                                  ? getValueFromLanguageObject("str_sgst")
                                  : "SGST"
                                } (${this.state.merchantInfo.SGST}%) : `}

                              <span>
                                {`${symbol}${parseFloat(
                                  this.getSGSTFromTotal(
                                    this.getTotalofCart(cartList)
                                  )
                                ).toFixed(2)}`}
                              </span>
                            </h5>
                          )}

                        {isMerchantGSTEnable &&
                          currentCatelogueType &&
                          currentCatelogueType.registerallow !==
                          "Catalogue_Jewellary" &&
                          this.state.merchantInfo.countryname !== "India" && (
                            <h5>
                              {`+ ${getValueFromLanguageObject("str_igst")
                                  ? getValueFromLanguageObject("str_igst")
                                  : "IGST"
                                } (${this.state.merchantInfo.IGST}%) : `}

                              <span>
                                {`${symbol}${parseFloat(
                                  this.getIGSTFromTotal(
                                    this.getTotalofCart(cartList)
                                  )
                                ).toFixed(2)}`}
                              </span>
                            </h5>
                          )}

                        <h5>
                          {`- ${getValueFromLanguageObject("discount_with_colun")
                              ? getValueFromLanguageObject(
                                "discount_with_colun"
                              )
                              : "Discount :"
                            }`}

                          <span>{`${symbol}${parseFloat(0).toFixed(2)}`}</span>
                        </h5>

                        <h5 className="grand-total">
                          {getValueFromLanguageObject(
                            "str_grand_total_with_colon"
                          )
                            ? getValueFromLanguageObject(
                              "str_grand_total_with_colon"
                            )
                            : "Grand Total :"}
                          <span>
                            {symbol}
                            {parseFloat(
                              this.getGrandTotal(
                                this.getTotalofCart(cartList),
                                this.getCGSTFromTotal(
                                  this.getTotalofCart(cartList)
                                ),
                                this.getSGSTFromTotal(
                                  this.getTotalofCart(cartList)
                                ),
                                this.getIGSTFromTotal(
                                  this.getTotalofCart(cartList)
                                ),
                                this.getShippingCharges(
                                  this.getTotalofCart(cartList)
                                )
                              )
                            ).toFixed(2)}
                          </span>
                        </h5>
                      </div>
                    )}
                  </li>
                  <li>
                    <div className="buttons">
                      <Link to={`/cart`} className="view-cart" onClick={this.handleCartClick}>
                        {isInquiry
                          ? getValueFromLanguageObject("str_view_inquiry")
                            ? getValueFromLanguageObject("str_view_inquiry")
                            : "view inquiry"
                          : getValueFromLanguageObject("str_view_cart")
                            ? getValueFromLanguageObject("str_view_cart")
                            : "view cart"}
                      </Link>

                      <Link to={`/checkout`} className="checkout" onClick={this.handleCartClick}>
                        {getValueFromLanguageObject("str_checkout")
                          ? getValueFromLanguageObject("str_checkout")
                          : "checkout"}
                      </Link>
                    </div>
                  </li>
                </>
              ) : (
                <li>
                  <h5>
                    {!isInquiry
                      ? getValueFromLanguageObject(
                        "str_no_cart_item_found_desc"
                      )
                        ? getValueFromLanguageObject(
                          "str_no_cart_item_found_desc"
                        )
                        : "You have not added any product in your cart."
                      : getValueFromLanguageObject(
                        "str_no_inquiry_item_found_desc"
                      )
                        ? getValueFromLanguageObject(
                          "str_no_inquiry_item_found_desc"
                        )
                        : "You have not added any product in your inquiry."}
                  </h5>
                </li>
              )}
            </ul>
          )}
        </div>
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isInquiry: state.settings.isInquiry,
    symbol: getCurrencySymbol(),
    cartCounter: state.cartCounter.cartCounter,
    updateQuantity: state.cartCounter.updateQuantity,
  };
}

export default connect(mapStateToProps, {
  isInquiryOrCart: isInquiryOrCart,
  counter: getCommonCounter,
})(withRouter(CartContainer));